/** Display helpers for the USD amount field. State keeps the raw value ("1000.5"); only the field shows commas. */

const PLAIN = /^\d+(\.\d*)?$/
const GROUPED = /^\d{1,3}(,\d{3})*(\.\d*)?$/

/** "1000000.5" -> "1,000,000.5". Anything that isn't plain digits is shown as typed, so validation still sees it. */
export function groupThousands(raw: string): string {
  if (!PLAIN.test(raw)) return raw
  const [whole, decimals] = raw.split('.')
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return decimals === undefined ? grouped : `${grouped}.${decimals}`
}

/**
 * Raw amount from the field's text. Commas the field inserted are dropped. Pasted text keeps its
 * commas unless they are clean thousands groups, so "100,50" (an Indonesian decimal comma) still
 * fails validation instead of silently becoming 10050.
 */
export function rawFromInput(text: string, pasted: boolean): string {
  if (!text.includes(',')) return text
  if (pasted && !GROUPED.test(text)) return text
  return text.replace(/,/g, '')
}

/** Caret index in `formatted` that sits after `charsBefore` non-comma characters. */
export function caretIndex(formatted: string, charsBefore: number): number {
  if (charsBefore <= 0) return 0
  let seen = 0
  for (let i = 0; i < formatted.length; i++) {
    if (formatted[i] !== ',') seen++
    if (seen === charsBefore) return i + 1
  }
  return formatted.length
}
